import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import AOS from 'aos';
import { Link } from 'react-router-dom';
import { RootState } from '../../core/data/redux/store';
import 'aos/dist/aos.css';
import { all_routes } from '../router/all_routes';

const Footer = () => {
  AOS.init();

  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  const handleScroll = () => {
    AOS.refresh();
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const { systemSettings } = useSelector((state: RootState) => ({
    systemSettings: state.auth.systemSettings,
  }));

  return (
    <>
      <footer className="footer">
        <div className="footer-top aos mt-0" data-aos="fade-down">
          <div className="container">
            <div className="row">
              <div className={'col-lg-5'}>
                <div className="footer-contact footer-widget mb-0">
                  <h5 className="footer-title">Contact Info</h5>
                  <div className="footer-contact-info">
                    <div className="footer-address">
                      <span>
                        <i className="feather icon-mail" />
                      </span>
                      <div className="addr-info">
                        <Link to={`mailto${systemSettings?.contact_email}`}>
                          {systemSettings?.contact_email}{' '}
                        </Link>
                      </div>
                    </div>
                    <div className="footer-address">
                      <span>
                        {' '}
                        <i className="feather icon-phone-call" />{' '}
                      </span>
                      <div className="addr-info">
                        <Link to={`tel:${systemSettings?.contact_phone}`}>
                          {systemSettings?.contact_phone}
                        </Link>
                      </div>
                    </div>

                    <div className="footer-address">
                      <span>
                        <i className="feather icon-map-pin" />
                      </span>
                      <div className="addr-info">
                        <p>{systemSettings?.default_pickup_location}</p>
                      </div>
                    </div>
                  </div>
                  <div className="footer-social-widget">
                    <ul className="nav-social"></ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container">
            <div className="copyright">
              <div className="row align-items-center">
                <div className="col-12">
                  <p className=" pt-4 border-0 border-top ">
                    <div className="col-12 ">
                      <p className="  text-territory ">
                        {' '}
                        Copyrights © 2025 FaiRental. All Rights Reserved.
                      </p>
                      <Link
                        to={all_routes.userAgreement}
                        className="text-territory"
                      >
                        
                        <u> User Agreement </u>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
